/**
 * Entry point for development and production PWA builds.
 */
import 'regenerator-runtime/runtime';
import App from './App';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { history } from './utils/history';

/**
 * EXTENSIONS AND MODES
 * =================
 * pluginImports.js is dynamically generated from extension and mode
 * configuration at build time.
 *
 * pluginImports.js imports all of the modes and extensions and adds them
 * to the window for processing.
 */
import { modes as defaultModes, extensions as defaultExtensions } from './pluginImports';
import loadDynamicConfig from './loadDynamicConfig';

loadDynamicConfig(window.config).then(config_json => {
    // Reset Dynamic config if defined
    if (config_json !== null) {
        window.config = config_json;
    }

    /**
     * Combine our appConfiguration with installed extensions and modes.
     * In the future appConfiguration may contain modes added at runtime.
     *  */
    const appProps = {
        config: window ? updatingWindowConfig(window.config) : {},
        defaultExtensions,
        defaultModes,
    };

    /** Create App */
    const app = React.createElement(App, appProps, null);
    /** Render — reuse existing root if entry ran twice (e.g. Webpack path casing) to avoid double mount */
    const rootEl = document.getElementById('root');
    if (!rootEl) {
        return;
    }
    const root =
        window.__SYMBIAN_REACT_ROOT__ || (window.__SYMBIAN_REACT_ROOT__ = createRoot(rootEl));
    root.render(app);
});

const updatingWindowConfig = config => {
    if (!config?.dataSources) {
        console.error('Config or dataSources is undefined.');
        return config;
    }

    config.dataSources.forEach(item => {
        // ── Main radiology datastore ──────────────────────────────────────────────
        if (item.sourceName === 'healthlake' && item?.configuration?.healthlake) {
            const { healthlake } = item.configuration;

            if (process.env.DATASTORE_ID && process.env.DATASTORE_URL) {
                healthlake.datastoreID = process.env.DATASTORE_ID;
                healthlake.endpoint = process.env.DATASTORE_URL;
            } else {
                healthlake.datastoreID = window.config.datastoreID || healthlake.datastoreID;
                healthlake.endpoint = window.config.endpoint || healthlake.endpoint;
            }
        }

        // ── Pathology WSI datastore ───────────────────────────────────────────────
        if (item.sourceName === 'pathology' && item?.configuration?.healthlake) {
            const { healthlake } = item.configuration;

            if (process.env.PATHOLOGY_DATASTORE_ID && process.env.PATHOLOGY_DATASTORE_URL) {
                healthlake.datastoreID = process.env.PATHOLOGY_DATASTORE_ID;
                healthlake.endpoint = process.env.PATHOLOGY_DATASTORE_URL;
            }
        }
    });

    return config;
};

export { history };
